import React, {useEffect, useRef, useState} from 'react';
import {Button, VStack, HStack, Text} from "@chakra-ui/react";
import {Calendar} from 'lucide-react';
import {DatePicker} from "@/components";
import {useLanguage} from "@/contexts/languageContext";

export const DateRangeDropdown = ({
                                         selectedItems,
                                        onChange,
                                        placeholder,
                                        dropdownProps = {},
                                        ...props
                                     }) => {
    const { t } = useLanguage();
    const parseSelectedDate = (value) => value ? new Date(value) : null;
    const getDayBoundary = (date, endOfDay = false) => {
        if (!date) return null;

        const boundary = new Date(date);
        boundary.setHours(endOfDay ? 23 : 0, endOfDay ? 59 : 0, endOfDay ? 59 : 0, endOfDay ? 999 : 0);
        return boundary.getTime();
    };
    const [minDate, setMinDate] = useState(parseSelectedDate(selectedItems?.min));
    const [maxDate, setMaxDate] = useState(parseSelectedDate(selectedItems?.max));
    const [isOpen, setIsOpen] = useState(false);
    const containerRef = useRef();

    useEffect(() => {
        const clickListener = (event) => {
            if (containerRef?.current && !containerRef.current.contains(event.target)) {
                setIsOpen(() => false);
            }
        }

        window.addEventListener('click', clickListener)

        return () => {
            window.removeEventListener('click', clickListener);
        }
    }, []);

    useEffect(() => {
        if (minDate || maxDate) {
            onChange({min: getDayBoundary(minDate), max: getDayBoundary(maxDate, true)});
        } else {
            onChange(null);
        }
    }, [minDate, maxDate]);

    const handleClear = (e) => {
        e.stopPropagation();
        setMinDate(null);
        setMaxDate(null);
        onChange(null);
    };

    const hasValue = minDate || maxDate;

    return <VStack position="relative" justify="center" ref={containerRef}>
        <Button
            bg={"secondary.500"}
            color={'white'}
            w="100%"
            onClick={() => setIsOpen(prevState => !prevState)}
            {...props}
        >
            <HStack gap="0.5rem">
                <Calendar size={16}/>
                <Text>
                    {hasValue ? `${minDate ? new Date(minDate).toLocaleDateString('fr-FR') : ''} - ${maxDate ? new Date(maxDate).toLocaleDateString('fr-FR') : ''}` : placeholder}
                </Text>
            </HStack>
        </Button>
        {isOpen &&
            <VStack
                onClick={(e) => e.stopPropagation()}
                left="0"
                w="auto"
                top="3rem"
                position="absolute"
                bg="white"
                borderRadius="0 0 .5rem .5rem"
                gap="0.5rem"
                p="1rem"
                zIndex={100}
                {...dropdownProps}
            >
                <HStack gap="0.5rem">
                    <DatePicker
                        date={minDate}
                        onChange={(date) => setMinDate(date)}
                        placeholderText={t('fields.from')}
                        isClearable
                        dateFormat="dd/MM/yyyy"
                    />
                    <Text>-</Text>
                    <DatePicker
                        date={maxDate}
                        onChange={(date) => setMaxDate(date)}
                        placeholderText={t('fields.to')}
                        isClearable
                        minDate={minDate}
                        dateFormat="dd/MM/yyyy"
                    />
                </HStack>
                {hasValue && (
                    <Button
                        size="sm"
                        variant="ghost"
                        onClick={handleClear}
                    >
                        {t('actions.clear')}
                    </Button>
                )}
            </VStack>
        }
    </VStack>;
};

export default DateRangeDropdown;
